export enum Sexe {
    Masculin,
    Feminin,
    Autre
}

export function Sexe_ToText(input: Sexe) {
    switch (input) {
        case Sexe.Masculin:
            return 'Masculin'
        case Sexe.Feminin:
            return 'Féminin'
        case Sexe.Autre:
            return 'Autre'
    }
}
